import { axios } from '../../../lib'

export const getAllDocuments = ({
  searchTerm = null,
  ids = null,
  fromIssueDate = null,
  toIssueDate = null,
  fromDueDate = null,
  toDueDate = null,
  syncStatuses = null,
  pointOfWorkTags = null,
  partnerCifs = null,
  organisationCifs = null,
  pageNumber = null,
  size = null,
  statuses = null,
  invoiceGroups = null,
  categories = null,
  orderByList = null
}) => {
  return axios.post('/documents/paginate', {
    searchTerm,
    ids,
    statuses,
    invoiceGroups,
    syncStatuses,
    categories,
    pointOfWorkTags,
    fromIssueDate,
    toIssueDate,
    fromDueDate,
    toDueDate,
    partnerCifs,
    organisationCifs,
    pagination: {
      ...(pageNumber == null || size == null
        ? { pageNumber: null, size: null }
        : { pageNumber, size }),
      orderByList
    }
  })
}
